// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import * as Turbo from "@hotwired/turbo"
window.Turbo = Turbo
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

import "cocoon-js"
import "jquery"
// import "rails_admin"

const MAX_FILE_SIZE = 15 * 1024 * 1024

const validateFileSize = (input) => {
	const file = input.files[0]

	if (file && file.size > MAX_FILE_SIZE) {
		input.setCustomValidity("O arquivo deve ter no máximo 15 MB.")
		return false
	}

	input.setCustomValidity("")
	return true
}

const setupWorkRegistrationFileValidation = () => {
	const form = document.querySelector("#work-registration-form")

	if (!form || form.dataset.fileSizeValidationInitialized) return

	const fileInputs = form.querySelectorAll(
		"#work_registration_work_attachment, #work_registration_proof_of_enrollment"
	)

	fileInputs.forEach((input) => {
		input.addEventListener("change", () => validateFileSize(input))
	})

	form.addEventListener("submit", (event) => {
		const filesAreValid = Array.from(fileInputs).every(validateFileSize)

		if (!filesAreValid) {
			event.preventDefault()
			form.reportValidity()
		}
	})

	form.dataset.fileSizeValidationInitialized = "true"
}

document.addEventListener("turbo:load", setupWorkRegistrationFileValidation)
document.addEventListener("DOMContentLoaded", setupWorkRegistrationFileValidation)
